// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  encryptionKey:"Y>Ebd4(Dc/&$_?.%v*5\"sRV6FQ9US~;W]72A)haCG!=fPM`[8{",
  googleTagID: 'GTM-TRB8HZ3K',
  googleMapsAPIKey: 'AIzaSyA11PefSLaKo9EX8z0c84OHPxqbw7B2xZo'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
